import { Skeleton } from '../Skeleton';
import styles from './pick.module.sass';
import cn from 'classnames';
import DOMPurify from 'dompurify';
import { PickNChooseHeaderBg } from '../SVGIcons/PickNChooseHeaderBg';
import { Separator } from '../Separator';

interface BaseProps extends React.HTMLAttributes<HTMLDivElement> {
    isLoading?: boolean;
}

interface LoadingProps extends BaseProps {
    isLoading: true;
    heading?: string;
    description?: string[];
    // image?: string;
}

interface LoadedProps extends BaseProps {
    isLoading?: false;
    heading: string;
    description?: string[];
    // image?: string;
}

type PickNChooseHeaderProps = LoadingProps | LoadedProps;

export const PickNChooseHeader = ({ heading, description, isLoading, ...props }: PickNChooseHeaderProps) => {
    if (isLoading) {
        return (
            <div {...props} className={cn(styles.pick, props.className)}>
                <Skeleton height={124} />
            </div>
        );
    }

    return (
        <div {...props} className={cn(styles.pick, props.className)}>
            <div className={cn(styles.content, 'container full-width')}>
                <strong className={styles.title}>{heading}</strong>
                <div className={styles.description}>
                    {description?.map((item, index) => {
                        return (
                            <div key={index}>
                                <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item) }} />
                            </div>
                        );
                    })}
                </div>
            </div>
            <div className={styles.bgimage}>
                <PickNChooseHeaderBg />
            </div>
            <Separator className={styles.separator} />
        </div>
    );
};
